export enum IntervalMatch {
  /** Záznam odpovídá, pokud začíná ve zkoumaném období. */
  RecordBeginsInRequested = "RecordBeginsInRequested",
  /** Záznam odpovídá, pokud se překrývá se zkoumaným obdobím. Dotek (bez překryvu) se nepočítá. */
  RecordOverlapsRequested = "RecordIntersectsWithRequested",
  /** Záznam odpovídá, pokud má společný alespoň okamžik se zkoumaným obdobím. Dotek (bez překryvu) se počítá. */
  RecordTouchesRequested = "RecordTouchesRequested",
}
